import request from '../utils/request'

export function getOpsResourcePositions(params) {
  return request({
    url: '/api/admin/ops/resource-positions',
    method: 'get',
    params
  })
}

export function createOpsResourcePosition(data) {
  return request({
    url: '/api/admin/ops/resource-positions',
    method: 'post',
    data
  })
}

export function updateOpsResourcePosition(id, data) {
  return request({
    url: `/api/admin/ops/resource-positions/${id}`,
    method: 'put',
    data
  })
}

export function enableOpsResourcePosition(id) {
  return request({
    url: `/api/admin/ops/resource-positions/${id}/enable`,
    method: 'post'
  })
}

export function disableOpsResourcePosition(id) {
  return request({
    url: `/api/admin/ops/resource-positions/${id}/disable`,
    method: 'post'
  })
}

export function deleteOpsResourcePosition(id) {
  return request({
    url: `/api/admin/ops/resource-positions/${id}`,
    method: 'delete'
  })
}
